import React from 'react';
import { Grid } from '@material-ui/core';
import Button from 'src/ui/library/Button';
import Dropdown from 'src/ui/library/Dropdown';
// import CsvParse from '@vtex/react-csv-parse';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import intl from 'react-intl-universal';
import WhatIfEmployeeRowContainer from '../containers/WhatIfEmployeeRowContainer';

class WhatIfCalculatorPres extends React.Component {
  render() {
    const {
      employees,
      onAddEmployee,
      onCalculate,
      // handleFileUpload,
      // keys,
      openDialog,
      onDialogClose,
      continueCalculate,
      currencySet,
      onChangeCurrency,
      outputCurrency,
      onDelete,
      onCancel,
    } = this.props;

    let disableDelete = true;
    Object.keys(employees).forEach(key => {
      if (employees[key].selected) {
        disableDelete = false;
      }
    });

    return (
      <div className="whatif-calc">
        <div className="whatif-calc-header">{intl.get('whatif.calculator.labels.header')}</div>
        <div className="whatif-calc-subheader">{intl.get('whatif.calculator.labels.subheader')}</div>
        <div className="whatif-calc-button-group">
          {Object.keys(employees).length < 5 && (
            <div className="whatif-calc-button" onClick={onAddEmployee}>
              {intl.get('whatif.calculator.labels.addScenario')}
            </div>
          )}
          {Object.keys(employees).length > 1 && (
            <div>
              <div className={'whatif-calc-button ' + (disableDelete ? 'disable' : '')} onClick={onDelete}>
                {intl.get('whatif.calculator.labels.delete')}
              </div>
              <div className="whatif-calc-button" onClick={onCancel}>
                {intl.get('whatif.calculator.labels.cancel')}
              </div>
            </div>
          )}
        </div>
        <Grid container spacing={3} className="whatif-calc-grid">
          {employees && Object.keys(employees).map(emp => <WhatIfEmployeeRowContainer {...this.props} mode="calc" key={emp} id={emp} />)}
          <Grid className="whatif-calc-footer" item container spacing={2} style={{ marginTop: '20px' }}>
            <Grid className="whatif-calc-footer-action" item>
              <Button styleType="primary" onClick={onCalculate}>
                Calculate
              </Button>
            </Grid>
            {/* <Grid className="whatif-calc-footer-action" item>
              {keys && (
                <CsvParse
                  keys={keys}
                  onDataUploaded={handleFileUpload}
                  onError={null}
                  render={handleChange => (
                    <div>
                      <input
                        accept=".csv"
                        id="file-input"
                        multiple={true}
                        className="whatif-calculator-upload"
                        type="file"
                        onChange={handleChange}
                      />
                      <label htmlFor="file-input">
                        <Button raised="true" component="span" styleType="secondary">
                          Upload
                        </Button>
                      </label>
                    </div>
                  )}
                />
              )}
            </Grid> */}
          </Grid>
        </Grid>

        <Dialog className="whatif-calculator-currency-dialog" open={openDialog} onClose={onDialogClose} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">Select Output Currency</DialogTitle>
          <DialogContent>
            <Dropdown
              className="whatif-calculator-currency-dropdown"
              required={true}
              options={currencySet.map(c => {
                return { value: c, label: c };
              })}
              id={`currency`}
              name={`currency`}
              label={`Currency`}
              onChange={onChangeCurrency}
              value={outputCurrency.value}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={onDialogClose} styleType="secondary">
              Cancel
            </Button>
            <Button onClick={continueCalculate} styleType="primary">
              Continue
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default WhatIfCalculatorPres;
